// import axios from "axios";
import { ProfileAPI } from "@/api/ProfileAPI";

// let profile_url = 'http://10.121.237.140/api/v1/users/';
// let update_profile_url = 'http://10.121.237.140/api/v1/users/';

export const profileModule = {
    state: () => ({
        profileData: {}
    }),
    getters: {
        profileData: state => state.profileData,
    },
    mutations: {
        setProfileData(state, userData) {
          state.profileData = userData
          localStorage.setItem('is-staff', userData.is_staff || '') 
        },
    },
    actions: {
      async getProfile({ commit, rootState }){
        return await ProfileAPI.getProfile(rootState.authorization.userId)
          .then(res => {
            commit("setProfileData", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async updateProfile({ commit, rootState }, userData){
        return await ProfileAPI.updateProfile(rootState.authorization.userId, userData)
          .then((response) => {
            return response.data.message;
          })
          .catch((error) => {
            let errorStatus;
            if(error.response?.data?.email && error.response?.data?.phone){
              errorStatus = 'updated error'
            }else if(error.response?.data?.email){
              if(error.response.data.email[0] == 'Введите правильный адрес электронной почты.'){
                errorStatus = 'email incorrect'
              }else{
                errorStatus = 'email Exist'
              }
            }else if(error.response?.data?.phone){
              if(error.response.data.phone[0] == 'Введите правильное значение.' || error.response.data.phone[0] == 'Убедитесь, что это значение содержит не менее 10 символов.'){
                errorStatus = 'phone incorrect'
              }else{
                errorStatus = 'phone Exist'
              }
            }else{
              errorStatus = error.response.status
            }

            // if (String(errorStatus).startsWith('4')){
            //   commit('clientError', null, { root: true })
            // }else if(String(errorStatus).startsWith('5')){
            //   commit('serverError', null, { root: true })
            // }
            
            return errorStatus;
          });
      },
      async emailVerification({ commit, rootState }, token) {
        return await ProfileAPI.verification(rootState.authorization.userId, token)
            .then((response) => {
              return response.status;
            })
            .catch((error) => {
              // let errorStatus = error.response.status
              return error.response.status;
            });
      },
      async settingMessage({ commit, rootState }, userData){
        return await ProfileAPI.settingMessage(rootState.authorization.userId, userData)
          .then((response) => {
            return response.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async changePassword({ commit, rootState }, userData){
        return await ProfileAPI.changePassword(rootState.authorization.userId, userData)
          .then((response) => {
            return response.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      }
    },
    namespaced: true
}